(() => {
  const ROOT_SELECTOR = '[data-thumbnail-swiper="true"]';
  const SWIPER_SELECTOR = '[data-thumbnail-swiper-root]';

  const destroy = (root) => {
    const el = root.querySelector(SWIPER_SELECTOR);
    if (el?.swiper) {
      el.swiper.destroy(true, true);
    }
    if (el) {
      el.removeAttribute('data-swiper-initialized');
    }
  };

  const initRoot = (root) => {
    if (!root || root.dataset.thumbnailSwiper !== 'true') return;
    const swiperEl = root.querySelector(SWIPER_SELECTOR);
    if (!swiperEl || swiperEl.dataset.swiperInitialized === 'true') return;
    if (!window.Swiper) return;

    const prevEl = root.querySelector('button[name="previous"]');
    const nextEl = root.querySelector('button[name="next"]');

    new window.Swiper(swiperEl, {
      slidesPerView: 4.2,
      spaceBetween: 8,
      speed: 400,
      watchOverflow: true,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      breakpoints: {
        750: {
          slidesPerView: 6.2,
          spaceBetween: 8,
        },
      },
    });

    swiperEl.dataset.swiperInitialized = 'true';
  };

  const boot = () => {
    requestAnimationFrame(() => {
      document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section?.querySelector) return;
    requestAnimationFrame(() => {
      section.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        destroy(root);
        initRoot(root);
      });
    });
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;
    if (!section?.querySelectorAll) return;
    section.querySelectorAll(ROOT_SELECTOR).forEach(destroy);
  });
})();
